export enum CaseActivityListMode {
    History = 1,
    TribunalPackSelection = 2,
    TribunalPackContents = 3
}
